module.exports = __webpack_public_path__ + "static/media/microsoft.a2bbe274.svg";